var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tab',{attrs:{"title":"Custom Mentorship Activities","active":_vm.active,"lazy":""}},[_c('custom-activity-table',{attrs:{"activity-type":"MA"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }